import React, { useEffect, useState } from 'react'
import useFetch from '../../../../hooks/useAxios'
import CatMap from '../../Cat/CatMap'
import ChooseFirstDateModal from '../../Cat/ModalFilter.js/ChooseFirstDateModal'
import ChooseReg from '../../Cat/ModalFilter.js/ChooseReg'
import ChooseSecDateModal from '../../Cat/ModalFilter.js/ChooseSecDateModal'
import CostInDays from '../../Cat/ModalFilter.js/CostInDays'
import GuestCount from '../../Cat/ModalFilter.js/GuestCount'
import Instancedelivery from '../../Cat/ModalFilter.js/Instancedelivery'
import TypeofResidence from '../../Cat/ModalFilter.js/TypeofResidence'
import CityModal from "../../Cat/ModalFilter.js/CityModal";
import ResidenceCard from './ResidenceCard'
import ResidenceFilter from './ResidenceFilter'
import ResidenceHeader from './ResidenceHeader'
import PersianPagination from '../../../shared/Paginatio'
const AdminResidences = () => {
  const [Stateinfo, setStateinfo] = useState([]);
  const [StateResults, setStateResults] = useState([]);
  const [OrderingSort, setOrderingSort] = useState(); //popular//minp//maxp

  const [chosenCity, setChoseCity] = useState([]
  );
  useEffect(() => {
    apiCityInfo.reFetch()
  }, [])

  
  

  const [totalPage, settotalPage] = useState(10);
  const [currentPage, setcurrentPage] = useState(1);

  const [mapshow, setmapshow] = useState(false);
  const [markers, setmarkers] = useState([{ lat: 51.505, lng: -0.09, name: 'London' },
  { lat: 48.8566, lng: 2.3522, name: 'Paris' },
  { lat: 52.5200, lng: 13.4050, name: 'Berlin' }])
  const [count, setcount] = useState(0);
  const [choseCityId, setchoseCityId] = useState([]); //city //start //end //count
  const [firstCostvalue, setfirstCostvalue] = useState(0);
  const [secCostValue, setsecCostValue] = useState();
  const [FastDeliveryValue, setFastDeliveryValue] = useState(false);
  const [ShowFastDeliveryModal, setShowFastDeliveryModal] = useState(false);
  const [GuestcountModal, setGuestcountModal] = useState(false);
  const [ShowCostModal, setShowCostModal] = useState(false);
  const [ShowResideceTypeModal, setShowResideceTypeModal] = useState(false);
  const [ShowCityModal, setShowCityModal] = useState(false);
  const [ShowRegModal, setShowRegModal] = useState(false);
  const [RegType, setRegType] = useState([]);
  const [ShowFirstDateModal, setShowFirstDateModal] = useState(false);
  const [ShowSecDateModal, setShowSecDateModal] = useState(false);
  const [FirstDateValue, setFirstDateValue] = useState( null );
  const [SecDateValue, setSecDateValue] = useState(null
  );
  const [status, setstatus] = useState("verified")

  const [inforesidence, setinforesidence] = useState([]);
const [choseType, setChosenType] = useState([])
const apiGetresidenceInfo = useFetch({
  method: "get",
  url:chosenCity.length > 0
    ? `api/admin/residences/${chosenCity.map(i => i.name).toString().replace(/,/g, "-")}`
    : `api/admin/residences`,
  noHeader: false,
  trigger: false,
  params: {
    verify_status:status? status : null,
  page:currentPage,
    instant:FastDeliveryValue?FastDeliveryValue:null,
  minp:firstCostvalue,
  maxp:secCostValue,
    endate : FirstDateValue!==null ?FirstDateValue : null,
    eldate:SecDateValue  !==null?SecDateValue : null,
    order:OrderingSort,
    reg:RegType.length>0 ? RegType.map(i => i.value).toString().replace(/,/g, "-") : null,
 // cap:count,ß
 // type:choseType.map(i => i.name).toString().replace(/,/g, "-"),
  },
  argFunc: res => {setinforesidence(res.data.data)
  settotalPage(res.data.count)
  }
});
useEffect(() => {
 if(FastDeliveryValue){
  apiGetresidenceInfo.reFetch()
 }
}, [
  FastDeliveryValue
])
 useEffect(() => {
  apiGetresidenceInfo.reFetch()
 }, [status])
 

const apiCityInfo = useFetch({
  method: "get",
  url: "api/locations",
  noHeader: true,
  trigger: false,
 
  argFunc: res => {
    setStateinfo(res.data);
    setStateResults(res.data);
  }
});
useEffect(() => {
  if(OrderingSort){
    apiGetresidenceInfo.reFetch()

  }
}, [OrderingSort])
useEffect(() => {
  if(currentPage ){
    apiGetresidenceInfo.reFetch()

  }
}, [currentPage])
const maxprice = useFetch({
  method: "get",
  url: "api/residences/max-price",
  noHeader: true,
  trigger: true,
  argFunc: res => {
    setsecCostValue(res.data.max_price)
    
  }
});

useEffect(() => {

    apiGetresidenceInfo.reFetch()

  
}, [chosenCity])


  const useFilter = ()=>{
    apiGetresidenceInfo.reFetch()
  }
  return (
    <div >
    
      <ResidenceHeader status={status} setstatus={setstatus} />
      <ResidenceFilter
       setShowRegModal={()=>setShowRegModal(true)}
       openFastDeliverModal={() => setShowFastDeliveryModal(true)}
       openCostModal={() => setShowCostModal(true)}
       openGuestModal={() => setGuestcountModal(true)}
       openCityModal={() => setShowCityModal(true)}
       opentTypeModal={() => setShowResideceTypeModal(true)}
       openFirstDateModal={() => setShowFirstDateModal(true)}
       openSecDateModal={() => setShowSecDateModal(true)}
       FirstDateValue={FirstDateValue}
       SecDateValue={SecDateValue}
       chosenCity={chosenCity}
       count={count}
       useFilter={useFilter}
       OrderingSort={OrderingSort}
       setOrderingSort={setOrderingSort}
       
      
      
      
      
      
      />
<div className='AdminResidences--grid mt-[36px]'>
{!apiGetresidenceInfo.loading ? inforesidence.map(i=><ResidenceCard  inforesidence={i}  /> ): null}

</div>
<div className="container">
        <PersianPagination total={totalPage} setcurrentPage={setcurrentPage} /> 
        </div>
{GuestcountModal &&
        <GuestCount
          closeModal={() => setGuestcountModal(false)}
          count={count}
          setCount={setcount}
        />}
      {ShowCostModal &&
        <CostInDays
          firstvalue={firstCostvalue}
          setfirstvalue={setfirstCostvalue}
          secvalue={secCostValue}
          setsecvalue={setsecCostValue}
          closeModal={() => setShowCostModal(false)}
        />}
      {ShowFastDeliveryModal &&
        <Instancedelivery
          closeModal={() => setShowFastDeliveryModal(false)}
          value={FastDeliveryValue}
          setvalue={setFastDeliveryValue}
        />}
      {ShowCityModal &&
        <CityModal
          setchoseCityId={setchoseCityId}
          choseCityId={choseCityId}
          setChoseCity={setChoseCity}
          chosenCity={chosenCity}
          closeModal={() => setShowCityModal(false)}
          Stateinfo={Stateinfo}
          setStateinfo={setStateinfo}
          StateResults={StateResults}
          setStateResults={setStateResults}
        />}
      {ShowResideceTypeModal &&
        <TypeofResidence
          choseType={choseType}
          setChosenType={setChosenType} 
          closeModal={() => setShowResideceTypeModal(false)}
         />}
      {ShowFirstDateModal &&
        <ChooseFirstDateModal
          closeModal={() => setShowFirstDateModal(false)}
          selectedDay={FirstDateValue}
          setSelectedDay={setFirstDateValue}
        />}
      {ShowSecDateModal &&
        <ChooseSecDateModal
          closeModal={() => setShowSecDateModal(false)}
          selectedDay={SecDateValue}
          setSelectedDay={setSecDateValue}
        />}
        {
          mapshow && <CatMap closeModal={()=>setmapshow(false)}   markerPos={markers} setMarkerPos={setmarkers} />
        }
        {
          ShowRegModal && <ChooseReg chosenReg={RegType} setChoseReg={setRegType} closeModal={()=>setShowRegModal(false)}/>
        }
    </div >
  )
}

export default AdminResidences